import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import { ORDERED_TABLE_COLUMNS, TABLE_COLUMNS } from '../constants';
import { HeaderCell } from '../../../components/table/HeaderCell';

const labels: Record<TABLE_COLUMNS, string> = {
  [TABLE_COLUMNS.EVENT]: 'Event',
  [TABLE_COLUMNS.DETAILS]: 'Details',
  [TABLE_COLUMNS.SOURCES]: 'Browser / Device / OS',
  [TABLE_COLUMNS.CREATED_AT]: 'Time',
  [TABLE_COLUMNS.OVERFLOW_MENU]: '',
};

const isSortable: Record<string, boolean> = {
  [TABLE_COLUMNS.CREATED_AT]: true,
};

const initialSortDirection: Record<string, SORT_DIRECTIONS> = {
  [TABLE_COLUMNS.EVENT]: SORT_DIRECTIONS.ASCENDING,
};

const headerColumns = ORDERED_TABLE_COLUMNS.map((id) => ({
  columnId: id,
  label: labels[id],
  isSortable: isSortable[id],
  initialSortDirection: initialSortDirection[id],
}));

export const HeaderRow = () => (
  <>
    {headerColumns.map((column) => (
      <HeaderCell {...column} key={column.columnId} />
    ))}
  </>
);
